import { constants, getErrorTextStyle } from '@bingads-webui-cc-react/common-styles';

export const getBaseABLStyles = () => ({
  accountBusinessLocation: {
    maxWidth: ({ isReadonly } = {}) => !isReadonly && constants.commonFormControl.maxWidth,
    '& label': {
      lineHeight: '24px',
    },
    '& .form-group': {
      '& > div, label.control-label': {
        width: '100%',
      },
    },
    '& .form-group div[role="alert"] .error': {
      ...getErrorTextStyle(),
    },
    '& div[role="alert"] .error': {
      ...getErrorTextStyle(),
    },
    '& #account-business-address-static-form .form-input-container, & #user-address-static-form .form-input-container': {
      wordBreak: 'break-word',
    },
  },
  addressForm: {
    '& #address-formPostalCode': {
      maxWidth: '50%',
    },
    '& .form-group:last-child': {
      marginBottom: '0px',
    },
  },
});
